import { MapContainer, TileLayer, Circle, CircleMarker, Popup, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const MILE = 1609.34;
const money = v => (v ? `$${Math.round(v).toLocaleString()}` : '—');
export const scoreColor = s => (s >= 70 ? '#10B981' : s >= 40 ? '#F59E0B' : '#94A3B8');

export function BuyerMap({ point, pins, items, onOpenBuyer }) {
  if (!point) return <p className="py-10 text-center text-sm text-gray-500" data-testid="pm-map-unavailable">This address couldn't be placed on the map.</p>;
  const byId = Object.fromEntries(items.map(b => [b.id, b]));
  const center = [point.lat, point.lng];
  return (
    <div className="relative overflow-hidden rounded-xl border border-gray-200" data-testid="pm-map">
      <MapContainer center={center} zoom={12} scrollWheelZoom className="h-[420px] w-full bg-[#0B0F17]">
        <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" className="dark-tiles" />
        <Circle center={center} radius={5 * MILE} pathOptions={{ color: '#3B82F6', weight: 1, fillColor: '#3B82F6', fillOpacity: 0.06, dashArray: '6 6' }} />
        {pins.filter(p => byId[p.buyer_id]).map(p => {
          const b = byId[p.buyer_id];
          const c = scoreColor(b.score);
          return (
            <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={8} pathOptions={{ color: '#0B0F17', weight: 2, fillColor: c, fillOpacity: 0.95 }}>
              <Popup>
                <div className="space-y-0.5 text-xs" data-testid={`pm-pin-popup-${p.id}`}>
                  <button onClick={() => onOpenBuyer(b.id)} className="font-semibold text-[#0073ea] hover:underline">{b.entity_name}</button>
                  <p>Score <b style={{ color: c }}>{b.score}</b> · {p.miles.toFixed(1)} mi away</p>
                  <p>{p.address}</p>
                  <p>{money(p.price)} · {p.purchase_date ? new Date(`${p.purchase_date}T00:00:00`).toLocaleDateString() : 'date unknown'}</p>
                </div>
              </Popup>
            </CircleMarker>
          );
        })}
        <CircleMarker center={center} radius={11} pathOptions={{ color: '#FFFFFF', weight: 3, fillColor: '#3B82F6', fillOpacity: 1 }}>
          <Tooltip permanent direction="top" offset={[0, -10]}>Your property</Tooltip>
        </CircleMarker>
      </MapContainer>
      <div className="pointer-events-none absolute bottom-3 left-3 z-[400] flex gap-3 rounded-lg bg-[#0B0F17]/85 px-3 py-1.5 text-[11px] text-slate-300 backdrop-blur" data-testid="pm-map-legend">
        <span className="flex items-center gap-1"><i className="h-2.5 w-2.5 rounded-full bg-[#10B981]" />70+</span>
        <span className="flex items-center gap-1"><i className="h-2.5 w-2.5 rounded-full bg-[#F59E0B]" />40–69</span>
        <span className="flex items-center gap-1"><i className="h-2.5 w-2.5 rounded-full bg-[#94A3B8]" />&lt;40</span>
        <span>· {pins.length} purchase{pins.length === 1 ? '' : 's'} within 5 mi</span>
      </div>
    </div>
  );
}
